import React, {useState} from 'react';
import {ReactComponent as SettingsIcon} from './settings.svg';
import {useTranslation} from 'react-i18next';
import {RulesModal} from '../RulesModal/RulesModal';
import {SettingsInner} from '../../Settings/SettingsInner';
import * as Popover from "@radix-ui/react-popover";

export const InfoMenu = () => {
    const {t} = useTranslation();
    const [openModal, setOpenModal] = useState(false);

    return (
        <React.Fragment>
            <div className="desktop:w-[373px] pl-[9px] grid tablet:grid-cols-[max-content_max-content_max-content] tablet:gap-[30px] notebook:gap-[45px] items-center notebook:pr-[27px]">
                <div className="cursor-pointer" onClick={() => setOpenModal(true)}>
                    <span className="max-tablet:hidden text-[#C6C7C9] text-[14px]">
                        {t('headerMenu.infoMenu.rules')}
                    </span>
                </div>
                <Popover.Root>
                    <Popover.Trigger asChild>
                        <div className="cursor-pointer">
                            <SettingsIcon className="w-[24px] h-[24px] tablet:w-[32px] tablet:h-[32px]" />
                        </div>
                    </Popover.Trigger>
                    <Popover.Portal container={document.getElementById('header-popover-root')}>
                        <div className="[&_[data-radix-popper-content-wrapper]]:!z-[60]">
                            <Popover.Content sideOffset={5}>
                                <SettingsInner buttonGroupByColumn={false} />
                                <Popover.Arrow className="fill-white" />
                            </Popover.Content>
                        </div>
                    </Popover.Portal>
                </Popover.Root>
            </div>
            <RulesModal openModal={openModal} setOpenModal={setOpenModal}/>

        </React.Fragment>
    );
};
